import { initEngageEvents } from "./analytics/engage-events";
import { initBackgroundVideo } from "./components/background-video";
import { initBlockQuote } from "./components/block-quote";
import { initBlockCompanyListing } from "./components/block-company-listing";
import { initBlockCompanyTimeline } from "./components/block-company-timeline";
import { initBlockMap } from "./components/block-map";
import { initBlockMedia } from "./components/block-media";
import { initBlockTextItems } from "./components/block-text-items";
import { initBreakpointTransitions } from "./components/breakpoint-transitions";
import { initButtonHover } from "./components/button-hover";
import { initContactCards } from "./components/contact-card";
import { initFadeIn } from "./components/fade-in";
import { initCountUp } from "./components/count-up";
import { initCookieConsent } from "./components/cookie-consent";
import { initCookieConsentDebug } from "./components/cookie-consent-debug";
import { initFormTextareaAutogrow } from "./components/form-textarea-autogrow";
import { initImageCaptions } from "./components/image-caption";
import { initLazyDatepicker } from "./components/lazy-datepicker";
import { initPressReleaseList } from "./components/press-release-list";
import { initScrollHeader } from "./components/scroll-header";
import { initScrollReveal } from "./components/scroll-reveal";
import { initSiteNavigation } from "./components/site-navigation";
import { safeInit, whenComponentsCssApplied } from "./startup";

// First screen (header, navigation, heroes): styled by the inlined site.css, so these run
// immediately.
function initSite(): void {
    safeInit([
        initCookieConsent,
        initCookieConsentDebug,
        initEngageEvents,
        initBackgroundVideo,
        initBreakpointTransitions,
        initButtonHover,
        initImageCaptions,
        initScrollHeader,
        // Before initScrollReveal: adds the data-scroll-reveal attributes it picks up.
        initFadeIn,
        initScrollReveal,
        initSiteNavigation,
        // Only listens for the first touch of a date field - must be in place before it happens.
        initLazyDatepicker,
    ]);
}

// Blocks and forms: styled by components.css, and several measure their own layout on init, so
// they wait until it's applied.
function initComponents(): void {
    safeInit([
        initBlockCompanyListing,
        initBlockCompanyTimeline,
        initBlockMap,
        // Measures where each block is - after scroll-reveal is observing (initSite).
        initBlockMedia,
        initBlockQuote,
        initBlockTextItems,
        initContactCards,
        initCountUp,
        // Measures already-filled textareas on init, against the form styles in components.css.
        initFormTextareaAutogrow,
        initPressReleaseList,
    ]);
}

function init(): void {
    initSite();
    void whenComponentsCssApplied().then(initComponents);
}

init();
